import { Component } from "@angular/core";
import { IonicPage, NavController } from "ionic-angular";

@IonicPage()
@Component({
  selector: "page-buy-vouchers",
  templateUrl: "buy-vouchers.html",
})
export class BuyVouchersPage {
  vouchers: any = BuyVouchersPage;

  constructor(private _navCtrl: NavController) {}

  ionViewDidLoad() {}

  ionViewWillEnter() {}

  ionViewWillLeave() {}

  handleBack() {
    this._navCtrl.pop();
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/buy-vouchers/buy-vouchers.ts